import React from 'react';
import { Link } from 'react-router-dom';
import './BlogCard.scss';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import { formatDateNumberInText } from '../../../../services/helpers';
import { useBlogNavigation } from '../../../../hooks/useBlogNavigation';
import { useMediaQuery } from 'react-responsive';

const BlogCard = ({ post, currentBlogState  }) => {
    const { navigateToArticle } = useBlogNavigation();
    const isSmallMobile = useMediaQuery({ maxWidth: 380 });
    const isSmallTab = useMediaQuery({ minWidth: 768, maxWidth: 845});
    
    if (!post) return null;

    const {
        Slug,
        Sujet,
        Auteur,
        Extrait,
        PhotoMiniature,
        DateEnvoi,
        Categorie
    } = post;


    // Fonction pour obtenir la couleur de la catégorie
    const getCategoryColor = (category) => {
        // Si la catégorie est un objet avec la propriété Couleur
        if (category && typeof category === 'object' && category.Couleur) {
            return category.Couleur;
        }

        // Fallback pour l'ancien système (compatibilité)
        const colors = {
            'Sécurité émotionnelle': 'blue',
            'Soutien émotionnel des mamans': 'green',
            'Coopération': 'purple',
            'Confiance en soi': 'pink',
            'Harcèlement scolaire': 'orange',
            'Accueil émotionnel': 'teal',
            'Injonctions et croyances collectives': 'indigo',
            'Violences éducatives ordinaires': 'red',
        };

        // Si c'est encore un string (période de migration)
        if (typeof category === 'string') {
            return colors[category] || 'gray';
        }

        return 'gray';
    };

    // Fonction pour obtenir le nom de la catégorie
    const getCategoryName = (category) => {
        if (category && typeof category === 'object' && category.Nom) {
            return category.Nom;
        }

        // Fallback pour l'ancien système
        if (typeof category === 'string') {
            return category;
        }

        return null;
    };

    const categoryColor = getCategoryColor(Categorie);
    const categoryName = getCategoryName(Categorie);

    // Gestionnaire de clic personnalisé
    const handleNavigateToArticle = (e) => {
        e.preventDefault();
        navigateToArticle(Slug, currentBlogState);
    };

    return (
        <article className="blog-card">
            <Link to={`/blog/${Slug}`} className="blog-card__link" onClick={handleNavigateToArticle}>
                {/* Image de l'article */}
                <div className="blog-card__image">
                    {PhotoMiniature ? (
                        <StrapiImageWithSkeleton
                            picture={PhotoMiniature}
                            loading="lazy"
                            className="blog-card__img"
                        />
                    ) : (
                        <div className="blog-card__placeholder">
                            <span className="blog-card__placeholder-icon">📰</span>
                        </div>
                    )}

                    {/* Badge catégorie */}
                    {Categorie && (
                        <div className={`blog-card__badge blog-card__badge--${categoryColor}`}
                            style={{ backgroundColor: categoryColor }}
                        >
                            {categoryName}
                        </div>
                    )}
                </div>

                {/* Contenu de la carte */}
                <div className="blog-card__content">
                    <div className="authorDate">
                        {/* Auteur */}
                        <span className="blog-card__author" >{Auteur || "Mélanie Bouthors"}</span>
                        {
                            isSmallMobile || isSmallTab ? <br /> : <span className="blog-card__author" > | </span>
                        }
                        {/* Date */}
                        {DateEnvoi && (
                            <time className="blog-card__date" dateTime={DateEnvoi}>
                                {formatDateNumberInText(DateEnvoi, 'long')}
                            </time>
                        )}
                    </div>

                    {/* Titre */}
                    <h3 className="blog-card__title">{Sujet}</h3>

                    {/* Extrait */}
                    {Extrait && (
                        <p className="blog-card__excerpt">{Extrait}</p>
                    )}

                    {/* Lien "Lire la suite" */}
                    <div className="blog-card__read-more">
                        <span className="blog-card__read-more-text">
                            Lire plus
                        </span>
                    </div>
                </div>
            </Link>
        </article>
    );
};

export default BlogCard;